import React from 'react';
import { motion } from 'framer-motion';
export function LocationSection() {
  return <section className="py-16 sm:py-24 bg-gray-50" data-id="element-150">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-151">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 leading-[1.15] tracking-tight mb-4 sm:mb-5" data-id="element-152">
          Cada foto queda asociada a su{' '}
          <span className="text-blue-600" data-id="element-153">contexto de obra.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-base sm:text-lg text-gray-600 leading-relaxed mb-8 sm:mb-10" data-id="element-154">
          Grupo, sector, conversación y momento exacto.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="inline-block px-5 sm:px-7 py-4 sm:py-5 bg-white border border-gray-200 rounded-2xl" data-id="element-155">
          <p className="text-sm sm:text-base text-gray-700 leading-relaxed" data-id="element-156">
            <span className="font-semibold text-gray-900" data-id="element-157">
              No necesitas precisión milimétrica.
            </span>
            <span className="block mt-1 text-gray-500" data-id="element-158">
              Necesitas entender qué estaba pasando.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}